import Component from '@ember/component';
import { action, computed, get, getProperties, set } from '@ember/object';
import { isEmpty, isPresent } from '@ember/utils';

/*
  attrs
  - changeset
  - property
  - label
  - labelIsHtmlSafe
    - if true, will treat the label as html safe
      - which allows you to have html elements in the label
    - default is false
  - showValidationErrors
  - disabled - boolean
  - selectOptions
    - array of { label: '', val: '' } for select options
    - can use interface SelectOption from lib/form-component-utils.ts
  - stringSelectOptions
    - array of strings for select options
  - booleanField
    - if true, then a select with Yes/No options will be presented
  - numberField
    - if true, then selected option val is converted to a number when setting the property on the changeset
  - onChange(value) - action fired when select is changed
*/

export default Component.extend({
  classNames: ['form-group'],
  classNameBindings: ['hasErrors'],
  label: null,
  changeset: null,
  // the associated property on the changeset
  property: null,
  showValidationErrors: false,
  // the 'type' attribute on the input element
  selectOptions: null,
  stringSelectOptions: null,
  booleanField: false,
  numberField: false,
  options: computed(
    'selectOptions',
    'stringSelectOptions',
    'booleanField',
    function () {
      let { stringSelectOptions, selectOptions, booleanField } = getProperties(
        this,
        'stringSelectOptions',
        'selectOptions',
        'booleanField',
      );
      if (booleanField) {
        return [
          {
            label: 'Yes',
            val: true,
          },
          {
            label: 'No',
            val: false,
          },
        ];
      } else if (!isEmpty(selectOptions)) {
        return selectOptions;
      } else if (!isEmpty(stringSelectOptions)) {
        return stringSelectOptions.map((option) => {
          return { label: option, val: option };
        });
      } else {
        return null;
      }
    },
  ),
  hasErrors: computed(
    'showValidationErrors',
    'changeset.errors.[]',
    'property',
    function () {
      if (this.showValidationErrors === false) {
        return false;
      }

      let property = this.property;
      return (
        get(this, 'changeset.errors').find(function (item) {
          return get(item, 'key') === property;
        }) != null
      );
    },
  ),

  onSelectChange: action(function (event) {
    const val = event.target.value;
    let parsedVal = val;
    if (this.booleanField) {
      if (val === 'true') {
        parsedVal = true;
      } else if (val === 'false') {
        parsedVal = false;
      }
    }
    if (this.numberField && isPresent(parsedVal)) {
      parsedVal = Number(parsedVal);
    }
    set(this, `changeset.${this.property}`, parsedVal);
    this.onChange?.(parsedVal);
  }),
});
